var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSteppersBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 458,
    viewBox: "0 0 814 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 -24H597V316C597 327.046 588.046 336 577 336H238C226.954 336 218 327.046 218 316V-24Z",
    fill: "#F3F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 248,
    width: 379,
    height: 88,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 371,
    cy: 291,
    r: 8,
    fill: "#B9BFC2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 291,
    r: 8,
    fill: "#B9BFC2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419,
    cy: 291,
    r: 8,
    fill: "#4DA3D4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 443,
    cy: 291,
    r: 8,
    fill: "#B9BFC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.5,
    y: 271.5,
    width: 92,
    height: 40,
    rx: 7.5,
    fill: "white",
    stroke: "#9CA5A9",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 477,
    y: 267,
    width: 101,
    height: 49,
    rx: 12,
    fill: "#268FCA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteppersBanner);
export default __webpack_public_path__ + "static/media/steppers-banner.00cbce248a63914984304228c8b777d4.svg";
export { ForwardRef as ReactComponent };